/**
 * loại lớp
 */
export default {

  Active: true,
  NonActive: false,
}
